<mat-form-field appearance="outline" class="w-full" [subscriptSizing]="passwordHints.length > 0 ? 'dynamic' : 'fixed'" *ngIf="control">
    <mat-label>{{ label }}</mat-label>
    <input
        matInput 
        [type]="showPassword ? 'text' : 'password'" 
        [formControl]="getControl()!"
        [placeholder]="placeholder"
        data-testid="new-password-input"
    />
    <button 
        mat-icon-button 
        matSuffix 
        type="button"
        (click)="togglePasswordVisibility()"
        class="text-on-surface-variant"
    >
        <mat-icon [svgIcon]="showPassword ? 'eye_opened' : 'eye_closed'"></mat-icon>
    </button>
    <mat-error *ngIf="control?.hasError('required') && !hasLengthValidator()">{{ 'New password is required' | translate }}</mat-error>
    <mat-error *ngIf="control?.hasError('whitespace')">{{ 'Password cannot contain whitespace' | translate }}</mat-error>
</mat-form-field>
<div *ngIf="hasAnyRules()" data-testid="password-requirements" class="mt-2">
    <div *ngFor="let hint of passwordHints"
        [ngClass]="{ '!text-[#68AB5B]': control?.value && isHintSatisfied(hint.key) }"
        [attr.data-testid]="'password-hint-' + hint.key"
        class="flex items-center gap-2 py-0.5 label-medium text-on-surface-variant">
        <mat-icon class="!w-4 !h-4 !text-[16px]" *ngIf="control?.value && isHintSatisfied(hint.key)">check_circle</mat-icon>
        <mat-icon class="!w-4 !h-4 !text-[16px]" *ngIf="!control?.value || !isHintSatisfied(hint.key)">radio_button_unchecked</mat-icon>
        <span>{{ hint.label | translate: hint.params }}</span>
    </div>
</div>
